import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";
import { AutomationChannel } from "./advanced-flow/common";
import { SchemaType } from "./advanced-flow/schemas/schemas";

export enum AiContextLibraryType {
  MARKETING = "MARKETING",
}

export const qualityValues = ["GOOD", "BAD"] as const;
export type Quality = (typeof qualityValues)[number];

const AutomationChannelValues = [
  AutomationChannel.Email,
  AutomationChannel.SMS,
] as const;

const SchemaTypeValues = Object.values(SchemaType) as [
  SchemaType,
  ...SchemaType[],
];

const baseSchema = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  title: z.string(),
  content: z.string(),
  quality: createEnum(qualityValues),
  feedback: z.string().nullish(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

const marketingSchema = baseSchema.extend({
  type: z.literal(AiContextLibraryType.MARKETING),
  triggerType: createEnum(SchemaTypeValues),
  strategy: z.string().optional(),
  scenarioType: z.string().optional(),
  channel: createEnum(AutomationChannelValues),
});

const AiContextLibrarySchema_ = marketingSchema;
export interface AiContextLibrary
  extends z.infer<typeof AiContextLibrarySchema_> {}
export const AiContextLibrarySchema: z.ZodType<AiContextLibrary> =
  AiContextLibrarySchema_;
